document.addEventListener 'turbo:load', ->
  $('[data-confirm]').on 'click', (e) ->
    if confirm(e.currentTarget.dataset.confirm)
      return true
    else
      e.preventDefault()
      e.stopImmediatePropagation()
      return false